import { useCallback, useEffect, useReducer, useState } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { selectEssDataConsumption } from 'shared/slice/essDataConsumptionSlice';
import { selectEssSwitch } from 'shared/slice/essSwitchSlice';
import { selectTelemetry } from 'features/telemetry/slice/telemetrySlice';
import { selectTesDataConsumption } from 'shared/slice/tesDataConsumptionSlice';
import { selectTesSwitch } from 'shared/slice/tesSwitchSlice';
import { selectTgsDataConsumption } from 'shared/slice/tgsDataConsumptionSlice';
import { selectTgsSwitch } from 'shared/slice/tgsSwitchSlice';
import {
  alignItemsFlexStart,
  flexBoxCenter,
  layerA90Deg,
  layerBDark,
} from 'shared/styles/commonStyles';
import SearchBar from './SearchBar';
import SwitchSpecification from './SwitchSpecification';
import Title from './Title';
import { filteredSuggestionsHandler } from 'shared/helpers/helpers';
import { useLocations } from 'shared/hooks';
import { selectUserPermissions } from 'shared/slice/userSlice';
import { PERMISSIONS } from 'shared/constants';


const initialState = {
  selectedEssMachines: [],
  selectedTgsMachines: [],
  selectedTesMachines: [],
  selectedEssDcMachines: [],
  selectedTgsDcMachines: [],
  selectedTesDcMachines: [],
};

const ACTIONS = {
  SETESSMACHINES: 'setEssMachines',
  SETTGSMACHINES: 'setTgsMachines',
  SETTESMACHINES: 'setTesMachines',
  SETESSDCMACHINES: 'setEssDcMachines',
  SETTGSDCMACHINES: 'setTgsDcMachines',
  SETTESDCMACHINES: 'setTesDcMachines',
};

const MainSwitchesSpecifications = ({
  telemetryData,
  scheduleData,
  selectedSystem,
  controlSelectionDisplay,
  isDc,
  selectSpecific,
}) => {
  const closeArrow = './images/white-triangle-pointing-right.svg';
  const openArrow = './images/white-triangle-pointing-down.svg';
  const essDropPinLogo = './images/ess-droppin-logo-for-nivo-chart.svg';
  const tgsDropPinLogo = './images/tgs-droppin-logo-for-nivo-chart.svg';
  const tesDropPinLogo = './images/tes-droppin-logo-for-nivo-chart.svg';
  const tgsTesDropPinLogo = './images/tgs-tes-droppin-logo-for-nivo-chart.svg';

  const telemetryState = useSelector(selectTelemetry);
  const isSearch = telemetryState.isSearch;

  const { flatEssSwitch } = useSelector(selectEssSwitch);
  const { flatTgsSwitch } = useSelector(selectTgsSwitch);
  const { flatTesSwitch } = useSelector(selectTesSwitch);
  const locations = useLocations();
  const { essDataConsumptionSwitch } = useSelector(selectEssDataConsumption);
  const { tesDataConsumptionSwitch } = useSelector(selectTesDataConsumption);
  const { tgsDataConsumptionSwitch } = useSelector(selectTgsDataConsumption);

  const [switchIdx, setSwitchIdx] = useState(null);
  const [isExpand, setIsExpand] = useState([]);
  const [inputSearch, setInputSearch] = useState(['']);
  const [expandButtonTitle, setExpandButtonTitle] = useState('expand');
  const [system, setSystem] = useState(null);
  const [src, setSrc] = useState([]);
  const [systemSwitches, setSystemSwitches] = useState();
  const [selectedLocations, setSelectedLocations] = useState([]);
  const [specificLocationsOpeningControl, setSpecificLocationsOpeningControl] =
    useState([]);
  const [totalDataConsumpOrEnergyConsump, setTotalDataConsumpOrEnergyConsump] =
    useState([]);
  const [totalUsageHours, setTotalUsageHours] = useState([]);
  const [totalNumOfSwt, setTotalNumOfSwt] = useState([]);
  const [isDataChanged, setIsDataChanged] = useState('');
  const [searchedSwtName, setSearchedSwtName] = useState('');
  const permissions = useSelector(selectUserPermissions);









  const displayStart =
    scheduleData.start.date !== null
      ? `${scheduleData.start.time.hour}:${scheduleData.start.time.minute} ${
          scheduleData.start.time.division
        }-${scheduleData.start.date.getDate()}/${
          scheduleData.start.date.getMonth() + 1
        }/${scheduleData.start.date.getFullYear()}`
      : ' -----';

  const displayEnd =
    scheduleData.end.date !== null
      ? `${scheduleData.end.time.hour}:${scheduleData.end.time.minute} ${
          scheduleData.end.time.division
        }-${scheduleData.end.date.getDate()}/${
          scheduleData.end.date.getMonth() + 1
        }/${scheduleData.end.date.getFullYear()}`
      : ' -----';

  const checkIsSystemAndSwitchesSelected =
    systemSwitches !== undefined && isSearch && controlSelectionDisplay;


  const [inputSwitchName, setInputSwitchName] = useState('');


  const initialDisplaySystemState = [
    [
      'ess - electric switch systems',
      '/images/ess-map-icon.svg',
      15,
      false,
      Object.keys(flatEssSwitch),
      'ess',
    ],
    [
      'tgs - typhoon gas systems',
      '/images/tgs-map-icon.svg',
      10,
      false,
      Object.keys(flatTgsSwitch),
      'tgs',
    ],









    [
      'tes - typhoon electric systems',
      '/images/tes-map-icon.svg',
      11,
      false,
      Object.keys(flatTesSwitch),
      'tes',
    ],
    [
      'ess - dc',
      '/images/ess-map-icon.svg',
      15,
      false,
      Object.keys(essDataConsumptionSwitch),
      'essDc',
    ],
    [
      'tgs/tes - dc',
      '/images/tgs-map-icon.svg',
      10,
      false,
      Object.keys(tgsDataConsumptionSwitch),
      'tgsDc',
    ],
    [
      'tes - typhoon electric systems',
      '/images/tes-map-icon.svg',
      15,
      false,
      Object.keys(tesDataConsumptionSwitch),
      'tesDc',
    ],
  ];

  const createIsExpandAndSrcState = useCallback(
    (data) => {
      const copyData = [...data];
      const copyData2 = [...data];
      const arrIsExpand = copyData?.fill(false);
      const arrowImages = copyData2?.fill(closeArrow);
      setIsExpand(arrIsExpand);
      setSrc(arrowImages);
    },
    [selectedSystem]
  );

  const createLocationsArr = (data) => {
    const dataLocationsArr = data.map((value) => false);
    const specificLocationArr = Object.values(flatTgsSwitch).map((el) => {
      const numOfEl = Object.keys(el).length;
      if (numOfEl === 0 || Object.values(el)[0]?.machineType) {
        return [];
      } else {
        const emptyArr = new Array(numOfEl);
        const arr = emptyArr;
        return arr.fill(false);
      }
    });













    const dataEnergyHoursArr = data.map((value) => '--');
    const numOfSwt = data.map((value) => 0);
    setTotalDataConsumpOrEnergyConsump(dataEnergyHoursArr);
    setTotalUsageHours(dataEnergyHoursArr);
    setSelectedLocations(dataLocationsArr);
    setSpecificLocationsOpeningControl(specificLocationArr);

    setTotalNumOfSwt(numOfSwt);
    setIsDataChanged((prev) => `${prev}1`);
  };

  const setSystemInfoHandler = (switchData, id) => {
    setSystemSwitches([initialDisplaySystemState[id]]);
    setSwitchIdx(id);
    createIsExpandAndSrcState(initialDisplaySystemState[id][4]);
    createLocationsArr(initialDisplaySystemState[id][4]);
    setSystem(switchData);
  };

  useEffect(() => {
    switch (selectedSystem) {
      case 'ess - electric switch systems - ec':
        setSystemInfoHandler(flatEssSwitch, 0);
        break;
      case 'tgs - typhoon gas systems - gc':
        setSystemInfoHandler(flatTgsSwitch, 1);


        break;
      case 'tes - typhoon electric systems - ec':
        setSystemInfoHandler(flatTesSwitch, 2);
        break;
      case 'ess - dc':
        setSystemInfoHandler(essDataConsumptionSwitch, 3);
        break;
      case 'tgs/tes - dc':
        setSystemInfoHandler(tgsDataConsumptionSwitch, 4);
        break;
      default:
        setSystemSwitches([initialDisplaySystemState[0]]);
        break;
    }
  }, [selectedSystem, isSearch, telemetryData]);















































  useEffect(() => {
    setInputSearch(['']);
  }, [telemetryData]);

  const handleClearSearch = useCallback(() => {
    setInputSwitchName('');
    const copyInputSearch = [...inputSearch];
    copyInputSearch[0] = '';
    setInputSearch(copyInputSearch);
    setSearchedSwtName('');
    setIsExpand(new Array(isExpand.length).fill(false));
    setSrc(new Array(src.length).fill(closeArrow));
  }, [inputSearch, isExpand, src]);

  const handleExpandSearch = useCallback(() => {
    if (expandButtonTitle === 'close') {
      setExpandButtonTitle('expand');
      setIsExpand(new Array(isExpand.length).fill(false));
      setSrc(new Array(src.length).fill(closeArrow));
    } else {
      setExpandButtonTitle('close');
      setIsExpand(new Array(isExpand.length).fill(true));
      setSrc(new Array(src.length).fill(openArrow));
    }
  }, [expandButtonTitle, isExpand, src]);



  const handleExpandEachLocation = useCallback(
    (idx) => {
      const copyIsExpand = [...isExpand];
      const copySrc = [...src];
      if (isExpand[idx]) {
        copyIsExpand[idx] = false;
        setIsExpand(copyIsExpand);
        copySrc[idx] = closeArrow;
        setSrc(copySrc);
      } else {
        copyIsExpand[idx] = true;
        setIsExpand(copyIsExpand);
        copySrc[idx] = openArrow;
        setSrc(copySrc);
      }
      setSearchedSwtName('');
    },
    [isExpand, src]
  );




  const [selectedSuggestionIdx, setSelectedSuggestionIdx] = useState(0);

  const [displaySuggestions, setDisplaySuggestions] = useState(false);
  const [activatedIndex, setActivatedIndex] = useState(null);
  const [machineSuggestions, setMachineSuggestions] = useState(null);




  const reducer = (state, action) => {
    switch (action.type) {
      case 'setEssMachines':
        return { ...state, selectedEssMachines: action.payload };
      case 'setTgsMachines':
        return { ...state, selectedTgsMachines: action.payload };
      case 'setTesMachines':
        return { ...state, selectedTesMachines: action.payload };
      case 'setEssDcMachines':
        return { ...state, selectedEssDcMachines: action.payload };
      case 'setTgsDcMachines':
        return { ...state, selectedTgsDcMachines: action.payload };
      case 'setTesDcMachines':
        return { ...state, selectedTesDcMachines: action.payload };
      default:
        throw new Error();
    }
  };

  const [state, dispatch] = useReducer(reducer, initialState);

  const dispatchHandler = (switchSystemData, actionType) => {
    const locations = [];
    Object.entries(switchSystemData).forEach(([location, value]) => {
      if (value?.devices) {
        Object.entries(value.devices).forEach(([machine, machineValues]) => {
          if (machineValues?.isSelected) locations.push(`${location} - ${machine}`);
        });
        return;
      }

      if (value?.subLocations) {
        Object.entries(value.subLocations).forEach(([specificLocation, group]) => {
          Object.entries(group?.devices || group || {}).forEach(
            ([machine, machineValues]) => {
              if (machineValues?.isSelected) {
                locations.push(`${location} - ${specificLocation} - ${machine}`);
              }
            }
          );
        });
        return;
      }

      Object.entries(value || {}).forEach(([key, machineOrGroup]) => {
        if (machineOrGroup?.isSelected) {
          locations.push(`${location} - ${key}`);
          return;
        }

        Object.entries(machineOrGroup || {}).forEach(([machine, machineValues]) => {
          if (machineValues?.isSelected) {
            locations.push(`${location} - ${key} - ${machine}`);
          }
        });
      });
    });

    dispatch({ type: actionType, payload: locations });
  };

  useEffect(() => {
    if (isSearch) {
      switch (selectedSystem) {
        case 'ess - electric switch systems - ec':
          dispatchHandler(flatEssSwitch, ACTIONS.SETESSMACHINES);
          break;
        case 'tgs - typhoon gas systems - gc':
          dispatchHandler(flatTgsSwitch, ACTIONS.SETTGSMACHINES);


          break;
        case 'tes - typhoon electric systems - ec':
          dispatchHandler(flatTesSwitch, ACTIONS.SETTESMACHINES);
          break;
        case 'ess - dc':
          dispatchHandler(essDataConsumptionSwitch, ACTIONS.SETESSDCMACHINES);
          break;
        case 'tgs/tes - dc':
          dispatchHandler(tgsDataConsumptionSwitch, ACTIONS.SETTGSDCMACHINES);
          dispatchHandler(tesDataConsumptionSwitch, ACTIONS.SETTESDCMACHINES);
          break;
        default:
          break;
      }
    }
  }, [isSearch, telemetryData]);




































































































































  const filteredSuggestions = filteredSuggestionsHandler(
    machineSuggestions,
    locations,
    inputSwitchName
  );


































  useEffect(() => {
    filteredSuggestions?.length >= 1 && inputSwitchName?.length >= 2
      ? setDisplaySuggestions(true)
      : setDisplaySuggestions(false);
  }, [filteredSuggestions, inputSwitchName]);

  const setSuggestionsHandler = (suggestions, id) => {
    setMachineSuggestions(suggestions);
    setActivatedIndex(id);
  };


  const handleMakeSuggestions = useCallback(
    (system) => {
      if (system === 'ess') {
        setSuggestionsHandler(state.selectedEssMachines, 0);


      } else if (system === 'tgs') {
        setSuggestionsHandler(state.selectedTgsMachines, 1);


      } else if (system === 'tes') {
        setSuggestionsHandler(state.selectedTesMachines, 2);


      } else if (system === 'essDc') {
        setSuggestionsHandler(state.selectedEssDcMachines, 3);


      } else if (system === 'tgsDc') {
        setSuggestionsHandler(state.selectedTgsDcMachines, 4);


      } else if (system === 'tesDc') {
        setSuggestionsHandler(state.selectedTesDcMachines, 5);


      }
    },
    [system]
  );





































































  const handleSelectSuggestion = useCallback(
    (idx, suggestion, selectedSuggestion) => {
      const arr = [...inputSearch];
      arr[idx] = suggestion;

      if (selectedSuggestion) {
        const splitSuggestion = suggestion.split(' - ');
        const locationName = splitSuggestion[0];
        let specificLocationName;
        let machineName;

        let result;
        if (splitSuggestion.length > 2) {
          specificLocationName = splitSuggestion[1];
          machineName = splitSuggestion[2];
          result = ['locationName', 'specificLocationName', 'machineName']
            .reduce((acc, cur) => {
              return `${acc} - ${locations.all[locationName][specificLocationName]?.devices[machineName][cur]}`;
            }, [])
            .slice(2);
        } else {
          machineName = splitSuggestion[1];
          result = ['locationName', 'machineName']
            .reduce((acc, cur) => {
              return `${acc} - ${locations.all[locationName]?.devices[machineName][cur]}`;
            }, [])
            .slice(2);
        }

        setSearchedSwtName(arr);
        setInputSearch([result]);
      } else {
        setInputSearch(arr);
      }

      if (suggestion?.length >= 2) {

        setSrc(src.fill(closeArrow));
        setExpandButtonTitle('expand');
      }
    },
    [inputSearch, locations.all, src]
  );













































  const handleSelect = (suggestion, selectedSuggestion = true) => {
    if (!suggestion) return;
    handleSelectSuggestion(0, suggestion, selectedSuggestion);
    setInputSwitchName('');
    setSelectedSuggestionIdx(-1);
    setDisplaySuggestions(false);
  };

  const closeSuggestionsHandler = () => {
    setIsExpand(new Array(isExpand.length).fill(false));
    setSrc(new Array(src.length).fill(closeArrow));
    setExpandButtonTitle('expand');
  };

  const handleKeyDown = (event) => {
    switch (event.key) {
      case 'Escape': {
        setInputSearch(['']);
        break;
      }
      case 'Enter': {
        const suggestion =
          selectedSuggestionIdx >= 0
            ? filteredSuggestions[selectedSuggestionIdx]
            : filteredSuggestions?.[0];
        handleSelect(suggestion, true);







        if (suggestion) {
          closeSuggestionsHandler();



        }

        break;
      }
      case 'ArrowUp': {
        selectedSuggestionIdx > 0
          ? setSelectedSuggestionIdx(selectedSuggestionIdx - 1)
          : setSelectedSuggestionIdx(filteredSuggestions.length - 1);
        break;
      }
      case 'ArrowDown': {
        selectedSuggestionIdx < filteredSuggestions.length - 1
          ? setSelectedSuggestionIdx(selectedSuggestionIdx + 1)
          : setSelectedSuggestionIdx(0);
        break;
      }
      default: {
        break;
      }
    }
  };


  return (
    <ShadowWrapper>
      <Wrapper>
        <FlexDiv>
          <Title
            image={
              checkIsSystemAndSwitchesSelected &&
              (systemSwitches[0][5] === 'ess' ||
              systemSwitches[0][5] === 'essDc'
                ? essDropPinLogo
                : systemSwitches[0][5] === 'tgs'
                ? tgsDropPinLogo
                : systemSwitches[0][5] === 'tes'
                ? tesDropPinLogo
                : systemSwitches[0][5] === 'tgsDc' ||
                  systemSwitches[0][5] === 'tesDc'
                ? tgsTesDropPinLogo
                : '')
            }
            system={checkIsSystemAndSwitchesSelected && systemSwitches[0][0]}
            consumption={
              checkIsSystemAndSwitchesSelected &&
              (systemSwitches[0][5] === 'tgs'
                ? 'gas consumption vs time'
                : systemSwitches[0][5] === 'tes' ||
                  systemSwitches[0][5] === 'ess'
                ? 'energy consumption vs time'
                : 'data consumption vs time')
            }
            time={
              checkIsSystemAndSwitchesSelected &&
              `${displayStart} - ${displayEnd}`
            }
            numUnits={
              checkIsSystemAndSwitchesSelected &&
              telemetryData?.length + ' units'
            }
          />
          <SearchBar
            handleClearSearch={handleClearSearch}
            handleExpandSearch={handleExpandSearch}
            buttonTitle={expandButtonTitle}
            systemSwitches={systemSwitches}
            handleSelectSuggestion={handleSelectSuggestion}
            setInputSwitchName={setInputSwitchName}
            setSelectedSuggestionIdx={setSelectedSuggestionIdx}
            handleMakeSuggestions={handleMakeSuggestions}
            handleKeyDown={handleKeyDown}
            switchIdx={switchIdx}
            displaySuggestions={displaySuggestions}
            activatedIndex={activatedIndex}
            selectedSuggestionIdx={selectedSuggestionIdx}
            filteredSuggestions={filteredSuggestions}
            setDisplaySuggestions={setDisplaySuggestions}
            inputSearch={inputSearch}
            disabled={!permissions[PERMISSIONS.SEARCH_TELEMETRY]}
          />
          <SwitchSpecification
            handleClearSearch={handleClearSearch}
            systemSwitches={systemSwitches}
            isExpand={isExpand}
            src={src}
            handleExpand={handleExpandEachLocation}
            system={system}
            inputSearch={inputSearch}
            setSelectedLocations={setSelectedLocations}
            selectedLocations={selectedLocations}
            specificLocationsOpeningControl={specificLocationsOpeningControl}
            setSpecificLocationsOpeningControl={
              setSpecificLocationsOpeningControl
            }
            totalDataConsumpOrEnergyConsump={totalDataConsumpOrEnergyConsump}
            setTotalDataConsumpOrEnergyConsump={
              setTotalDataConsumpOrEnergyConsump
            }
            totalUsageHours={totalUsageHours}
            setTotalUsageHours={setTotalUsageHours}
            totalNumOfSwt={totalNumOfSwt}
            setTotalNumOfSwt={setTotalNumOfSwt}
            swtName={selectedSystem?.split(' ')[0]}
            telemetryData={telemetryData}
            isDataChanged={isDataChanged}
            isDc={isDc}
            searchedSwtName={searchedSwtName}
            setSearchedSwtName={setSearchedSwtName}
            setIsExpand={setIsExpand}
            selectSpecific={selectSpecific}
          />
        </FlexDiv>
      </Wrapper>
    </ShadowWrapper>
  );
};

export default MainSwitchesSpecifications;

const ShadowWrapper = styled.div`
  width: 1202px;
  height: auto;
  padding-top: 2px;
  padding-bottom: 2px;

  ${layerBDark}

  border-radius: 8px;
  opacity: 1;
  ${flexBoxCenter}
`;

const Wrapper = styled.div`
  width: 1198px;
  height: auto;

  ${layerA90Deg}

  border-radius: 6px;
  opacity: 1;
  ${alignItemsFlexStart}
  flex-direction: column;
  gap: 4px;
`;

const FlexDiv = styled.div`
  width: 100%;
  height: auto;
  margin-left: 3px;
`;
